module.exports = __webpack_public_path__ + "static/media/kiran-more-pic.31cf2c79.png";